import type { LuzmoAuthToken } from '@polyai/common/api/resources/luzmo/types';

import { doGet, doPost } from 'api/request';
import type {
  AnalyticsIntegration,
  Interval,
  LuzmoAuthTokenPayload,
  SafetyDataResponse,
  StandardisedDataResponse,
} from 'api/resources/analytics/types';
import { LOGGER_TYPE } from 'api/types';

export const getLuzmoAuthToken = (
  accountId: string,
  projectId: string,
  integrationId?: string,
  suborganisation: string = 'PolyAI',
  theme?: { [style: string]: any },
  css: string = '',
) => {
  const payload: LuzmoAuthTokenPayload = {
    suborganisation,
    theme,
    css,
    metadata: { account_id: accountId, project_id: projectId },
  };

  if (integrationId) {
    payload.integration_id = integrationId;
  }

  return doPost<LuzmoAuthToken>(
    `accounts/${accountId}/projects/${projectId}/analytics/auth`,
    LOGGER_TYPE.ANALYTICS,
    payload,
  );
};

export const getIntegration = (accountId: string, projectId: string) => {
  return doGet<AnalyticsIntegration>(
    `accounts/${accountId}/projects/${projectId}/analytics/integrations`,
    LOGGER_TYPE.ANALYTICS,
  );
};

export const getStandardisedData = (
  accountId: string,
  projectId: string,
  interval: Interval,
  startTime: string,
  endTime: string,
) => {
  return doGet<StandardisedDataResponse>(
    `accounts/${accountId}/projects/${projectId}/analytics/standardized-data`,
    LOGGER_TYPE.ANALYTICS,
    {
      params: {
        interval,
        start_time: startTime,
        end_time: endTime,
      },
    },
  );
};

export const getSafetyData = (
  accountId: string,
  projectId: string,
  interval: Interval,
  startTime: string,
  endTime: string,
) => {
  return doGet<SafetyDataResponse>(
    `accounts/${accountId}/projects/${projectId}/analytics/standardized-data/safety`,
    LOGGER_TYPE.ANALYTICS,
    {
      params: {
        interval,
        start_time: startTime,
        end_time: endTime,
      },
    },
  );
};
